@if (userIsLogguedIn()) {
  <app-menu-top
  [(menuState)]="menuState"></app-menu-top>
}

@if (userIsLogguedIn()) {
  <app-menu-left [menuState]="menuState"></app-menu-left>
}

<div class="app-body" [ngClass]="{ 'has-menu': userIsLogguedIn(), 'is-menu-reduced': menuState.isReduced}">
  <router-outlet [appAutoLogoutOnInactivity]="userIsLogguedIn()"></router-outlet>
  @if (isPanneauTachesVisible()) {
    <app-taches-panel [tache]="tacheEditee()" [isUpsertOnly]="isUpsertTacheOnly()" (fermer)="fermerTachesPanel()"></app-taches-panel>
  }

</div>


<app-notification-toast></app-notification-toast>
